import React, { useEffect, useState } from 'react';
import { ReactComponent as PastaVermelho } from '../../../assets/novosicones/MeuImovel/documentos/pastaVermelho.svg';
import { ReactComponent as PastaDirecional } from '../../../assets/novosicones/MeuImovel/documentos/pastaDirecional.svg';
import { ReactComponent as PastaRiva } from '../../../assets/novosicones/MeuImovel/documentos/pastaRiva.svg';
import { Spinner } from '../../StyledComponent';
import Fade from '@material-ui/core/Fade';
import { getDocumentos } from '../../../services/meuImovel';
import { getUrlFotoS3 } from '../../../services/endPointsNotificacoes';
import NotFoundError from '../NotFoundError';
import './styles.scss';
import CloseButton from '../../Reutilizaveis/CloseButton';

const Documentos = ({
  idEmpreendimentoImovelSelecionado,
  numeroContrato,
  corEmpreendimento,
  statusImovel,
  oportunidadeIdSalesForce,
}) => {
  // documentos do empreendimento
  const [documentosEmpreendimento, setDocumentosEmpreendimento] = useState([]);

  // documentos do proprietário
  const [documentosContrato, setDocumentosContrato] = useState([]);

  const [loadingDocumentos, setLoadingDocumentos] = useState(true);

  const tipoDocumentos = {
    'Ata de Assembleia': 'Empreendimento',
    'Averbação do Habite-se': 'Empreendimento',
    'Contrato Conf Dívida': 'Contrato',
    'Contrato de Compra e Venda': 'Contrato',
    'Contrato de Financiamento': 'Contrato',
    'Convenção de Condomínio': 'Empreendimento',
    'Habite-se': 'Empreendimento',
    Informativo: 'Empreendimento',
    'Kit Acabamento': 'Contrato',
    'Manual do proprietário': 'Empreendimento',
    'Matrícula Autenticada': 'Contrato',
    'Relatório comissão de representantes': 'Empreendimento',
    'Vaga de Garagem': 'Contrato',
    'Contrato Registrado E Matrícula': 'Contrato',
  };

  useEffect(() => {
    if (idEmpreendimentoImovelSelecionado) loadDocumentos();
  }, [idEmpreendimentoImovelSelecionado]);

  async function loadDocumentos() {
    setLoadingDocumentos(true);
    let resultGetDocumentos = '';
    if (numeroContrato != '') {
      resultGetDocumentos = await getDocumentos(
        numeroContrato,
        idEmpreendimentoImovelSelecionado,
        oportunidadeIdSalesForce
      );

      //agrupa contrato Contrato de Compra e Venda - chancelado em Contrato de Compra e Venda
      resultGetDocumentos.forEach((document) => {
        if (document?.TipoDocumento?.includes('Chancelado')) {
          document.TipoDocumento = 'Contrato de Compra e Venda';
        }
      });

      resultGetDocumentos.forEach((document) => {
        if (document?.TipoDocumento?.includes('Chancelado')) {
          document.TipoDocumento = 'Contrato de Compra e Venda';
        }
      });

      if (!resultGetDocumentos) {
        setDocumentosEmpreendimento([]);
        setDocumentosContrato([]);
      } else {
        const filteredDocuments = () =>
          resultGetDocumentos.filter(
            (doc) => doc.IdArquivo || doc.IdFile || doc.Url
          );

        await getUpdatedUrlS3Documents(filteredDocuments());
        loadArrayTiposDocumentos(filteredDocuments());
      }

      setLoadingDocumentos(false);
    }
  }

  function loadArrayTiposDocumentos(documentos) {
    if (documentos.length > 0) {
      let resultFilterEmpreendimento = documentos.filter((documento) => {
        const a = tipoDocumentos[documento.TipoDocumento];
        return a == 'Empreendimento';
      });

      let resultFilterContrato = documentos.filter((documento) => {
        const a = tipoDocumentos[documento.TipoDocumento];
        return a == 'Contrato';
      });
      setDocumentosEmpreendimento(
        organizeDocuments(resultFilterEmpreendimento)
      );
      setDocumentosContrato(organizeDocuments(resultFilterContrato));
      setLoadingDocumentos(false);
    }
  }

  const organizeDocuments = (documents) => {
    const organized = [];
    for (let document of documents) {
      const sameTypes = organized.find(
        (o) => o.type === document.TipoDocumento
      );
      if (sameTypes) {
        sameTypes.documents.push(document);
      } else {
        organized.push({ type: document.TipoDocumento, documents: [document] });
      }
    }
    return organized;
  };

  function getUserDocuments() {
    const userDocuments = Array.from(
      document.getElementsByClassName('documentosUsuario')
    );

    return userDocuments;
  }

  function showDocuments(tipoDocumento) {
    const userDocuments = getUserDocuments();

    userDocuments.forEach((item) => {
      item.classList.remove('showDocumentos');
      if (item.accessKey == tipoDocumento) {
        item.classList.add('showDocumentos');
      }
    });
  }

  function hideDocuments() {
    const userDocuments = getUserDocuments();

    userDocuments.forEach((item) => {
      item.classList.remove('showDocumentos');
    });
  }
  let Pasta = '';
  if (corEmpreendimento == '#1D3054') Pasta = PastaRiva;
  else Pasta = PastaDirecional;
  if (loadingDocumentos) return <Spinner />;

  async function getUpdatedUrlS3Documents(documents) {
    for (let document of documents) {
      if (document?.IdArquivo || document?.IdFile) {
        const { data } = await getUrlFotoS3(
          document?.IdArquivo || document?.IdFile
        );
        document.Url = data;
      }
    }
  }

  return (
    <Fade in>
      <div
        className='centralized-space-between documentosOut'
        style={{ alignItems: 'flex-start', gap: 16 }}
      >
        {/* verificação se o imóvel é ou não distratado, se for distratado não pode mostrar os documentos do empreendimento */}
        <div
          style={
            statusImovel == 'Distratado' ? { display: 'none' } : { display: '' }
          }
          className='documentosOut__tipoDocumento'
        >
          {documentosEmpreendimento.length == 0 && (
            <NotFoundError
              className='semDocumentos'
              text={
                'Sem documentos relacionados ao empreendimento para exibir.'
              }
            />
          )}
          {documentosEmpreendimento.length > 0 && (
            <div className='centralized-column listaDocumentos'>
              <span className='listaDocumentos__tipo'>Empreendimento:</span>
              <span className='listaDocumentos__tipoDescricao'>
                Documentos relacionados do empreendimento:
              </span>
              <div className='centralized listaDocumentos__documentos  '>
                {documentosEmpreendimento.map((documento) => (
                  <div
                    key={documento.type}
                    className='listaDocumentos__documentos__item'
                  >
                    {documento.documents.length > 1 && (
                      <a
                        className='centralized'
                        onClick={() => {
                          showDocuments(documento.type);
                        }}
                      >
                        <Pasta style={{ fill: corEmpreendimento }} />
                        <span>{documento.type}</span>
                      </a>
                    )}
                    {documento.documents.length == 1 && (
                      <a
                        href={documento.documents[0].Url}
                        target='_blank'
                        rel='noreferrer'
                        className='centralized'
                      >
                        <Pasta style={{ fill: corEmpreendimento }} />
                        <span>{documento.type}</span>
                      </a>
                    )}

                    <Fade in>
                      <div
                        className='centralized-column documentosUsuario hideDocumentos'
                        accessKey={documento.type}
                      >
                        <CloseButton
                          tamanho={18}
                          onClick={hideDocuments}
                          corBackground={'white'}
                        />
                        {documento.documents.map((item) => (
                          <p
                            style={{ fontSize: '10px', margin: '5px' }}
                            key={item.Id}
                          >
                            <a href={item.Url} target='_blank' rel='noreferrer'>
                              {item.Nome}
                            </a>
                          </p>
                        ))}
                      </div>
                    </Fade>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className='documentosOut__tipoDocumento'>
          {documentosContrato.length == 0 && (
            <p className='semDocumentos'>
              Sem documentos relacionados ao proprietário para exibir.
            </p>
          )}

          {documentosContrato.length > 0 && (
            <div className='centralized-column listaDocumentos'>
              <span className='listaDocumentos__tipo'>Proprietário:</span>
              <span className='listaDocumentos__tipoDescricao'>
                Documentos relacionados do proprietário:
              </span>
              <div className='centralized listaDocumentos__documentos  centralized-space-between'>
                {documentosContrato.map((documento) => (
                  <>
                    <div
                      key={documento.type}
                      className='listaDocumentos__documentos__item'
                    >
                      {documento.documents.length > 1 && (
                        <a
                          className='centralized-column'
                          onClick={() => {
                            showDocuments(documento.type);
                          }}
                        >
                          <PastaVermelho />
                          <span>{documento.type}</span>{' '}
                        </a>
                      )}

                      {documento.documents.length == 1 && (
                        <a
                          className='centralized'
                          href={documento.documents[0].Url}
                          target='_blank'
                          rel='noreferrer'
                        >
                          <PastaVermelho />
                          <span>{documento.type}</span>
                        </a>
                      )}
                      <Fade in>
                        <div
                          className='centralized-column documentosUsuario hideDocumentos'
                          accessKey={documento.type}
                        >
                          <CloseButton
                            tamanho={18}
                            onClick={hideDocuments}
                            corBackground={'white'}
                          />
                          {documento.documents.map((item) => (
                            <>
                              <p
                                style={{ fontSize: '10px', margin: '5px' }}
                                key={item.Id}
                              >
                                <a
                                  href={item.Url}
                                  target='_blank'
                                  rel='noreferrer'
                                >
                                  {item.Nome}
                                </a>
                              </p>
                            </>
                          ))}
                        </div>
                      </Fade>
                    </div>
                  </>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </Fade>
  );
};

export default Documentos;
